export const SETTING_HEADER_PREFIX = "X-IF-MIDDLEWARE-SETTING";

export const buildSettingHeaderKey = (key: string) =>
  `${SETTING_HEADER_PREFIX}-${key.replaceAll("_", "-")}`;
